import { SearchParams } from '@domain/app';
import useQueryParam from '@hooks/use-query-param';

export const useStatusFromQueryParam = () => {
    const status = useQueryParam(SearchParams.STATUS);

    if (typeof status !== 'string' || status.length === 0) {
        return null;
    }

    return status;
};
